var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSliderArrows(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.64649 0.646522C6.45123 0.45126 6.13465 0.45126 5.93938 0.646522L0.939491 5.64641C0.744229 5.84168 0.744229 6.15826 0.939491 6.35352L5.93938 11.3534C6.13465 11.5487 6.45123 11.5487 6.64649 11.3534L7.35338 10.6465C7.54865 10.4513 7.54865 10.1347 7.35338 9.93941L3.76749 6.35352C3.57223 6.15826 3.57223 5.84168 3.76749 5.64642L7.35338 2.06052C7.54865 1.86526 7.54865 1.54868 7.35338 1.35341L6.64649 0.646522ZM13.3534 11.3534C13.5486 11.5487 13.8652 11.5487 14.0605 11.3534L19.0604 6.35352C19.2556 6.15826 19.2556 5.84168 19.0604 5.64642L14.0605 0.646522C13.8652 0.45126 13.5486 0.45126 13.3534 0.646522L12.6465 1.35342C12.4512 1.54868 12.4512 1.86526 12.6465 2.06052L16.2324 5.64641C16.4276 5.84168 16.4276 6.15826 16.2324 6.35352L12.6465 9.93941C12.4512 10.1347 12.4512 10.4513 12.6465 10.6465L13.3534 11.3534Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderArrows);
export default __webpack_public_path__ + "static/media/slider-arrows.d9429e51.svg";
export { ForwardRef as ReactComponent };